import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import {HttpClientModule} from '@angular/common/http'

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { RegisterPageModule } from '../pages/register/register.module';
import { GaugePageModule } from '../pages/gauge/gauge.module';
import { Push } from '@ionic-native/push';
import { GlobalProvider } from '../providers/global/global';
import { SetPointPageModule } from '../pages/set-point/set-point.module';
import { DetailPageModule } from '../pages/detail/detail.module';
import { ConsultaPageModule } from '../pages/consulta/consulta.module';
import { LoginPageModule } from '../pages/login/login.module';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ClientPageModule } from '../pages/client/client.module';
import { AmbientPageModule } from '../pages/ambient/ambient.module';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { BannerAlarmPage } from '../pages/banner-alarm/banner-alarm';
import { BannerAlarmPageModule } from '../pages/banner-alarm/banner-alarm.module';
import { AuthProvider } from '../providers/auth/auth';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    BannerAlarmPage,
    ListPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    LoginPageModule,
    RegisterPageModule,
    GaugePageModule,
    SetPointPageModule,
    DetailPageModule,
    ConsultaPageModule,
    ChartsModule,
    ClientPageModule,
    AmbientPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    BannerAlarmPage,
    ListPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    InAppBrowser,
    Push,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    GlobalProvider,
    AuthProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts